var y = Object.defineProperty;
var b = (e, n, a) => n in e ? y(e, n, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[n] = a;
var t = (e, n, a) => b(e, typeof n != "symbol" ? n + "" : n, a);
function Mt() {
  var e;
  try {
    return typeof ((e = window == null ? void 0 : window.mixpanel) == null ? void 0 : e.get_distinct_id) == "function" ? window.mixpanel.get_distinct_id() : void 0;
  } catch (n) {
    console.error(n);
    return;
  }
}
function S() {
  var e, n;
  return typeof window < "u" && ((n = (e = window.location) == null ? void 0 : e.hostname) == null ? void 0 : n.indexOf("hs-app.local.hsenv.io")) >= 0;
}
function h() {
  return typeof window < "u" && !!window.__STORYBOOK_API__;
}
function T(e) {
  var n;
  return S() ? `${e}${((n = window.hsGlobal) == null ? void 0 : n.mixpanelSuffix) ?? ""}` : e;
}
const I = {
  identify: (e) => {
    console.log("@helpscout/analytics identify:", e);
  },
  reset: () => {
    console.log("@helpscout/analytics reset");
  },
  track: (e, n) => {
    console.log("@helpscout/analytics track:", e, n);
  }
}, R = {
  identify: () => {
  },
  reset: () => {
  },
  track: () => {
  }
};
function r() {
  var e;
  return typeof window < "u" && typeof ((e = window.mixpanel) == null ? void 0 : e.track) == "function" ? window.mixpanel : O();
}
function O() {
  return S() || h() ? I : R;
}
const P = 3e3, V = 50, _ = 500, D = 6, M = 1e3, U = "hs-mixpanel-flag-overrides", p = "hs-mixpanel-flag-cache", l = /* @__PURE__ */ new Map();
F();
let u = null;
function A(e) {
  if (typeof window > "u") return null;
  try {
    const n = window.localStorage.getItem(U);
    if (!n) return null;
    const a = JSON.parse(n), o = a == null ? void 0 : a[e];
    return typeof o == "boolean" || typeof o == "string" ? o : null;
  } catch {
    return null;
  }
}
function F() {
  if (!(typeof window > "u"))
    try {
      const e = window.sessionStorage.getItem(p);
      if (!e) return;
      const n = JSON.parse(e);
      for (const [a, o] of Object.entries(n))
        (typeof o == "boolean" || typeof o == "string") && l.set(a, o);
    } catch {
    }
}
function B(e, n) {
  if (!(typeof window > "u"))
    try {
      const a = window.sessionStorage.getItem(p), o = a ? JSON.parse(a) : {};
      o[e] = n, window.sessionStorage.setItem(p, JSON.stringify(o));
    } catch {
    }
}
async function G(e = P) {
  var a, o, i;
  if (typeof window > "u") return !1;
  const n = Date.now();
  for (; typeof ((o = (a = window.mixpanel) == null ? void 0 : a.flags) == null ? void 0 : o.get_variant_value) != "function"; ) {
    const d = Date.now() - n;
    if (typeof ((i = window.mixpanel) == null ? void 0 : i.track) != "function" && d >= _ || d >= e) return !1;
    await new Promise((E) => setTimeout(E, V));
  }
  return !0;
}
function L() {
  return u || (u = G().then((e) => (e || (u = null), e))), u;
}
async function W(e) {
  const a = await r().flags.get_variant_value(e, !1), o = typeof a == "boolean" || typeof a == "string" ? a : !1;
  return l.set(e, o), B(e, o), o;
}
async function g(e, n = 0) {
  var a;
  for (let o = 0; ; o++) {
    if (await L() && typeof ((a = r().flags) == null ? void 0 : a.get_variant_value) == "function")
      try {
        return await W(e);
      } catch (d) {
        return console.error(d), !1;
      }
    if (o >= n) return !1;
    await new Promise((i) => setTimeout(i, M));
  }
}
async function Ut(e) {
  await Promise.all(
    e.filter((n) => !l.has(n)).map((n) => g(n, D))
  );
}
function Ft(e) {
  const n = N(e);
  return n === void 0 ? void 0 : n === !0;
}
function N(e) {
  const n = A(e);
  return n !== null ? n : l.get(e);
}
async function Bt(e) {
  const n = A(e);
  return n !== null ? n === !0 : l.has(e) ? l.get(e) === !0 : await g(e) === !0;
}
const K = "user_";
function Gt(e) {
  var n, a;
  if (!e) {
    console.error(
      "@helpscout/analytics: Cannot identify user for MixPanel without a user ID"
    );
    return;
  }
  try {
    (a = (n = r()).identify) == null || a.call(
      n,
      T(`${K}${e}`)
    );
  } catch (o) {
    console.error(
      "@helpscout/analytics: Error identifying user for MixPanel",
      o
    );
  }
}
function Lt() {
  var e, n;
  try {
    (n = (e = r()).reset) == null || n.call(e);
  } catch (a) {
    console.error(
      "@helpscout/analytics: Error resetting identity for MixPanel",
      a
    );
  }
}
const Y = [
  "Clicked Button",
  "Clicked Copy Workflow Button",
  "Clicked Copy Workflow to Mailbox Button",
  "Clicked Link",
  'In App Tour "Next" Button Clicked',
  'In App Tour "Close" Button Clicked',
  "Signed Up"
];
class s {
  /**
   * Constructor for BaseEvent
   * @param properties - Properties for the event
   */
  constructor(n) {
    /** Event properties */
    t(this, "properties");
    this.properties = n;
  }
  /**
   * Get trackable properties. This is the properties that will be sent to the
   * tracking service. The default implementation adds the following properties:
   * - `companyId` - The company ID
   * - `memberId` - The member ID
   * - `userId` - The user ID
   * Override this method to add additional properties.
   * @protected
   */
  getTrackableProperties() {
    return {
      ...this.properties ?? {},
      companyId: window.hsGlobal.companyId,
      memberId: Y.includes(this.name) ? window.hsGlobal.memberId : void 0,
      userId: window.hsGlobal.memberId
    };
  }
  /**
   * Get the track function. This is the function that will be used to track the
   * event. The default implementation checks if the environment is a storybook
   * environment or a local environment. If it is a storybook environment, it
   * returns the console track function. If it is a local environment, it returns
   * the console track function. Otherwise, it returns the noop track function.
   * Override this method if you want to use a different tracking service or
   * strategy.
   * @protected
   */
  getAnalyticsService() {
    return r();
  }
  /**
   * Track the event. This is the function that will be called to track the event.
   * The default implementation adds the following properties to the trackable
   * properties:
   * - `companyId` - The company ID
   * - `memberId` - The member ID
   * - `userId` - The user ID
   *
   * @returns The current instance of the event
   */
  track() {
    try {
      const n = this.getTrackableProperties();
      this.getAnalyticsService().track(this.name, n);
    } catch (n) {
      console.error("@helpscout/analytics track failed", n);
    }
    return this;
  }
}
class $ extends s {
  constructor({
    pageVisited: a,
    state: o
  }) {
    super({
      pageVisited: a ?? (typeof window < "u" ? window.location.pathname : "/"),
      ...o && { state: o }
    });
    t(this, "name", "pageVisited");
  }
}
class v extends s {
}
class H extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "Clicked Button");
  }
}
class j extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "Clicked Link");
  }
}
class J extends v {
  constructor({
    step: a
  }) {
    var o, i;
    super({
      signUpStep: a,
      com_id: ((o = window.hsGlobal) == null ? void 0 : o.companyId) ?? "",
      usr_id: ((i = window.hsGlobal) == null ? void 0 : i.memberId) ?? ""
    });
    t(this, "name", "Signed Up");
  }
}
class z extends s {
  constructor(a) {
    super({
      currentAvailabilityStatus: a == null ? void 0 : a.currentAvailabilityStatus
    });
    t(this, "name", "accountDropdownOpened");
  }
}
class X extends s {
  constructor(a) {
    super({
      itemType: a.itemType,
      itemValue: a.itemValue
    });
    t(this, "name", "accountDropdownItemClicked");
  }
}
class q extends s {
  constructor(a) {
    super({
      currentStatus: a.currentStatus,
      intendedStatus: a.intendedStatus
    });
    t(this, "name", "availabilityToggleClicked");
  }
}
class Q extends s {
  constructor(a) {
    super({
      previousStatus: a.previousStatus,
      newStatus: a.newStatus,
      success: a.success,
      errorType: a.errorType
    });
    t(this, "name", "availabilityChanged");
  }
}
class Z extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsEnabled");
  }
}
class ee extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsDisabled");
  }
}
class ne extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsDeleted");
  }
}
class te extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsAppliedToInbox");
  }
}
class se extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsReviewNotificationClicked");
  }
}
class ae extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUserCreated");
  }
}
class oe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUserModified");
  }
}
class ie extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicConvoOverride");
  }
}
class de extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicValueEnabled");
  }
}
class le extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicValueDisabled");
  }
}
class ce extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedSearch");
  }
}
class re extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedReports");
  }
}
class ue extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedWorkflows");
  }
}
class me extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedViews");
  }
}
class pe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedColumns");
  }
}
class ve extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedColumns");
  }
}
class Ce extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentRemovedFromColumns");
  }
}
class xe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedViews");
  }
}
class Ee extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedWorkflows");
  }
}
class we extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedSearch");
  }
}
class Se extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedSort");
  }
}
class Ae extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "contactSentimentConversationsOpened");
  }
}
class ge extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "docsArticleCreated");
  }
}
class fe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "docsAiAnswersPromoClicked");
  }
}
class m extends s {
  constructor(n) {
    if (!n.inboxForwarderContext && typeof window < "u") {
      const o = window.location.pathname.includes("/settings/inbox");
      super({
        ...n,
        inboxForwarderContext: o ? "inbox-settings" : "setup-guide"
      });
    } else
      super(n);
  }
}
class ke extends m {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderCancelClicked");
  }
}
class ye extends m {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderConnectChannelsClicked");
  }
}
class be extends m {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderConnectDifferentEmailClicked");
  }
}
class he extends m {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderFinishLaterClicked");
  }
}
class Te extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companySidebarToggled");
  }
}
class Ie extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyListOpened");
  }
}
class Re extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileOpened");
  }
}
class Oe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileTabOpened");
  }
}
class Pe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companySidepanelOpened");
  }
}
class Ve extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileEditSaved");
  }
}
class _e extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyPropertiesUpsellClicked");
  }
}
class De extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyOverviewTimeframeChanged");
  }
}
class Me extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "contactProfileTabOpened");
  }
}
class Ue extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementAdded");
  }
}
class Fe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementUpdated");
  }
}
class Be extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementDeleted");
  }
}
class Ge extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improveButtonClicked");
  }
}
class Le extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementGenerated");
  }
}
class f extends s {
}
class We extends f {
  constructor() {
    super(...arguments);
    t(this, "name", 'In App Tour "Next" Button Clicked');
  }
}
class Ne extends f {
  constructor() {
    super(...arguments);
    t(this, "name", 'In App Tour "Close" Button Clicked');
  }
}
class Ke extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxBlankSlateClicked");
  }
}
class Ye extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxConnectBannerClicked");
  }
}
class $e extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxWelcomeModalClicked");
  }
}
class He extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideStepViewed");
  }
}
class je extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideStepCtaClicked");
  }
}
class Je extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideHelpLinkClicked");
  }
}
class ze extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideDismissed");
  }
}
class Xe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideRestored");
  }
}
class k extends s {
}
class qe extends k {
  constructor() {
    super(...arguments);
    t(this, "name", "viewClosedConversationsIncluded");
  }
}
class Qe extends k {
  constructor() {
    super(...arguments);
    t(this, "name", "viewClosedConversationsExcluded");
  }
}
class C extends s {
}
class x extends s {
}
class Ze extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsMenuOpened");
  }
}
class en extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsAddMenuOpened");
  }
}
class nn extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsReset");
  }
}
class tn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsReordered");
  }
}
class sn extends x {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnAdded");
  }
}
class an extends x {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnRemoved");
  }
}
class on extends x {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnHeaderClicked");
  }
}
class dn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewSorted");
  }
}
class ln extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalOpened");
  }
}
class cn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalClosed");
  }
}
class rn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalSelectAllClicked");
  }
}
class un extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalClearAllClicked");
  }
}
class mn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopied");
  }
}
class pn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersEnabled");
  }
}
class vn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersDisabled");
  }
}
class Cn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxAiAnswersEnabled");
  }
}
class xn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxAiAnswersDisabled");
  }
}
class En extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "prepaidAiAnswersContactUsClicked");
  }
}
class wn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "prepaidAiAnswersManageClicked");
  }
}
class Sn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "threadReactionAdded");
  }
}
class An extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "threadReactionRemoved");
  }
}
class gn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inAppBeaconMessageShown");
  }
}
class fn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSetupStarted");
  }
}
class kn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconContactStepCompleted");
  }
}
class yn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconCustomizeStepCompleted");
  }
}
class bn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSelfServiceStepCompleted");
  }
}
class hn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSetupCompleted");
  }
}
class Tn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentCreated");
  }
}
class In extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDeleted");
  }
}
class Rn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentPublished");
  }
}
class On extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentTestSessionStarted");
  }
}
class Pn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDocSourceAdded");
  }
}
class Vn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDocSourceRemoved");
  }
}
class _n extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentWebsiteSourceAdded");
  }
}
class Dn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentWebsiteSourceRemoved");
  }
}
class Mn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentNameChanged");
  }
}
class Un extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentIdentityChanged");
  }
}
class Fn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentConnectionActivated");
  }
}
class Bn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStepViewed");
  }
}
class Gn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStepCompleted");
  }
}
class Ln extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupCancelled");
  }
}
class Wn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupSourceAdded");
  }
}
class Nn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupSourceRemoved");
  }
}
class Kn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupCompleted");
  }
}
class Yn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStarted");
  }
}
class $n extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupNextClicked");
  }
}
class Hn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupBackClicked");
  }
}
class jn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupTryItOutClicked");
  }
}
class Jn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupAddKnowledgeClicked");
  }
}
class zn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersSimulationStarted");
  }
}
class Xn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "globalBannerCtaClicked");
  }
}
class qn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailGenerated");
  }
}
class Qn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailAdded");
  }
}
class Zn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailUpdated");
  }
}
class et extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailDeleted");
  }
}
class nt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "experienceKit");
  }
}
class tt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "roadblockFooterCtaClicked");
  }
}
class st extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "roadblockCancellationBridgeLanded");
  }
}
class at extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "scoutCtaClicked");
  }
}
class ot extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "scoutKnowledgeAdded");
  }
}
class it extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "scoutExclusionAdded");
  }
}
class dt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "scoutRoleCreated");
  }
}
class lt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "showOriginalClicked");
  }
}
class ct extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalSettingsViewed");
  }
}
class rt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalSettingsSaved");
  }
}
class ut extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalEnabled");
  }
}
class mt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalDisabled");
  }
}
class pt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectClicked");
  }
}
class vt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectionSubmitted");
  }
}
class Ct extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectSetupCancelled");
  }
}
class xt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelDisconnectClicked");
  }
}
class Et extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaOnboardingViewed");
  }
}
class wt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaCreateStarted");
  }
}
class St extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPolicyCreated");
  }
}
class At extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPolicyToggled");
  }
}
class gt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPoliciesReordered");
  }
}
class ft extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaLearnMoreClicked");
  }
}
function kt() {
  const e = window.hsGlobal.accountDropdown;
  return e != null && e.isOwner ? "owner" : e != null && e.isAdmin ? "admin" : e != null && e.isLightUser ? "light user" : "user";
}
class c extends s {
  getTrackableProperties() {
    return { ...super.getTrackableProperties(), user_role: kt() };
  }
}
class yt extends c {
  constructor() {
    super(...arguments);
    t(this, "name", "reportViewed");
  }
}
class bt extends c {
  constructor() {
    super(...arguments);
    t(this, "name", "reportFilterChanged");
  }
}
class ht extends c {
  constructor() {
    super(...arguments);
    t(this, "name", "reportDrilldownOpened");
  }
}
class Tt extends c {
  constructor() {
    super(...arguments);
    t(this, "name", "reportExported");
  }
}
class It extends c {
  constructor() {
    super(...arguments);
    t(this, "name", "reportViewSaved");
  }
}
class Rt extends c {
  constructor() {
    super(...arguments);
    t(this, "name", "reportViewSelected");
  }
}
class Ot extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "triageSuggestionsShown");
  }
}
class Pt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "triageSuggestionAccepted");
  }
}
const w = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountDropdownItemClickedEvent: X,
  AccountDropdownOpenedEvent: z,
  AiAgentConnectionActivatedEvent: Fn,
  AiAgentCreatedEvent: Tn,
  AiAgentDeletedEvent: In,
  AiAgentDocSourceAddedEvent: Pn,
  AiAgentDocSourceRemovedEvent: Vn,
  AiAgentIdentityChangedEvent: Un,
  AiAgentNameChangedEvent: Mn,
  AiAgentPublishedEvent: Rn,
  AiAgentSetupAddKnowledgeClickedEvent: Jn,
  AiAgentSetupBackClickedEvent: Hn,
  AiAgentSetupCancelledEvent: Ln,
  AiAgentSetupCompletedEvent: Kn,
  AiAgentSetupNextClickedEvent: $n,
  AiAgentSetupSourceAddedEvent: Wn,
  AiAgentSetupSourceRemovedEvent: Nn,
  AiAgentSetupStartedEvent: Yn,
  AiAgentSetupStepCompletedEvent: Gn,
  AiAgentSetupStepViewedEvent: Bn,
  AiAgentSetupTryItOutClickedEvent: jn,
  AiAgentTestSessionStartedEvent: On,
  AiAgentWebsiteSourceAddedEvent: _n,
  AiAgentWebsiteSourceRemovedEvent: Dn,
  AiAnswersDisabledEvent: vn,
  AiAnswersEnabledEvent: pn,
  AiAnswersSimulationStartedEvent: zn,
  AvailabilityChangedEvent: Q,
  AvailabilityToggleClickedEvent: q,
  BeaconContactStepCompletedEvent: kn,
  BeaconCustomizeStepCompletedEvent: yn,
  BeaconSelfServiceStepCompletedEvent: bn,
  BeaconSetupCompletedEvent: hn,
  BeaconSetupStartedEvent: fn,
  ChannelConnectClickedEvent: pt,
  ChannelConnectSetupCancelledEvent: Ct,
  ChannelConnectionSubmittedEvent: vt,
  ChannelDisconnectClickedEvent: xt,
  ClickedButtonEvent: H,
  ClickedLinkEvent: j,
  CompanyListOpenedEvent: Ie,
  CompanyOverviewTimeframeChangedEvent: De,
  CompanyProfileEditSavedEvent: Ve,
  CompanyProfileOpenedEvent: Re,
  CompanyProfileTabOpenedEvent: Oe,
  CompanyPropertiesUpsellClickedEvent: _e,
  CompanySidebarToggledEvent: Te,
  CompanySidepanelOpenedEvent: Pe,
  ContactProfileTabOpenedEvent: Me,
  ContactSentimentConversationsOpenedEvent: Ae,
  CustomerPortalDisabledEvent: mt,
  CustomerPortalEnabledEvent: ut,
  CustomerPortalSettingsSavedEvent: rt,
  CustomerPortalSettingsViewedEvent: ct,
  DocsAiAnswersPromoClickedEvent: fe,
  DocsArticleCreatedEvent: ge,
  ExperienceKitEvent: nt,
  GlobalBannerCtaClickedEvent: Xn,
  GuardrailAddedEvent: Qn,
  GuardrailDeletedEvent: et,
  GuardrailGeneratedEvent: qn,
  GuardrailUpdatedEvent: Zn,
  ImproveButtonClickedEvent: Ge,
  ImprovementAddedEvent: Ue,
  ImprovementDeletedEvent: Be,
  ImprovementGeneratedEvent: Le,
  ImprovementUpdatedEvent: Fe,
  InAppBeaconMessageShownEvent: gn,
  InAppTourCloseButtonClickedEvent: Ne,
  InAppTourNextButtonClickedEvent: We,
  InboxAiAnswersDisabledEvent: xn,
  InboxAiAnswersEnabledEvent: Cn,
  InboxBlankSlateClickedEvent: Ke,
  InboxConnectBannerClickedEvent: Ye,
  InboxForwarderCancelClickedEvent: ke,
  InboxForwarderConnectChannelsClickedEvent: ye,
  InboxForwarderConnectDifferentEmailClickedEvent: be,
  InboxForwarderFinishLaterClickedEvent: he,
  InboxWelcomeModalClickedEvent: $e,
  PageVisitedEvent: $,
  PrepaidAiAnswersContactUsClickedEvent: En,
  PrepaidAiAnswersManageClickedEvent: wn,
  ReportDrilldownOpenedEvent: ht,
  ReportExportedEvent: Tt,
  ReportFilterChangedEvent: bt,
  ReportViewSavedEvent: It,
  ReportViewSelectedEvent: Rt,
  ReportViewedEvent: yt,
  RoadblockCancellationBridgeLandedEvent: st,
  RoadblockFooterCtaClickedEvent: tt,
  ScoutCtaClickedEvent: at,
  ScoutExclusionAddedEvent: it,
  ScoutKnowledgeAddedEvent: ot,
  ScoutRoleCreatedEvent: dt,
  SentimentRemovedFromColumnsEvent: Ce,
  SentimentUsedColumnsEvent: ve,
  SentimentUsedSearchEvent: we,
  SentimentUsedSortEvent: Se,
  SentimentUsedViewsEvent: xe,
  SentimentUsedWorkflowsEvent: Ee,
  SetupGuideDismissed: ze,
  SetupGuideHelpLinkClicked: Je,
  SetupGuideRestored: Xe,
  SetupGuideStepCtaClicked: je,
  SetupGuideStepViewed: He,
  ShowOriginalClickedEvent: lt,
  SignedUpEvent: J,
  SlaCreateStartedEvent: wt,
  SlaLearnMoreClickedEvent: ft,
  SlaOnboardingViewedEvent: Et,
  SlaPoliciesReorderedEvent: gt,
  SlaPolicyCreatedEvent: St,
  SlaPolicyToggledEvent: At,
  ThreadReactionAddedEvent: Sn,
  ThreadReactionRemovedEvent: An,
  TopicConvoOverrideEvent: ie,
  TopicUsedColumnsEvent: pe,
  TopicUsedReportsEvent: re,
  TopicUsedSearchEvent: ce,
  TopicUsedViewsEvent: me,
  TopicUsedWorkflowsEvent: ue,
  TopicUserCreatedEvent: ae,
  TopicUserModifiedEvent: oe,
  TopicValueDisabledEvent: le,
  TopicValueEnabledEvent: de,
  TopicsAppliedToInboxEvent: te,
  TopicsDeletedEvent: ne,
  TopicsDisabledEvent: ee,
  TopicsEnabledEvent: Z,
  TopicsReviewNotificationClickedEvent: se,
  TriageSuggestionAcceptedEvent: Pt,
  TriageSuggestionsShownEvent: Ot,
  ViewClosedConversationsExcludedEvent: Qe,
  ViewClosedConversationsIncludedEvent: qe,
  ViewColumnAddedEvent: sn,
  ViewColumnHeaderClickedEvent: on,
  ViewColumnRemovedEvent: an,
  ViewColumnSortedEvent: dn,
  ViewColumnsAddMenuOpenedEvent: en,
  ViewColumnsCopiedEvent: mn,
  ViewColumnsCopyModalClearAllClickedEvent: un,
  ViewColumnsCopyModalClosedEvent: cn,
  ViewColumnsCopyModalOpenedEvent: ln,
  ViewColumnsCopyModalSelectAllClickedEvent: rn,
  ViewColumnsMenuOpenedEvent: Ze,
  ViewColumnsReorderedEvent: tn,
  ViewColumnsResetEvent: nn
}, Symbol.toStringTag, { value: "Module" })), Vt = (e) => {
  const n = e.replace(/Event$/, "");
  return n.length === 0 ? "" : n.charAt(0).toLowerCase() + n.slice(1);
}, _t = () => {
  const e = {};
  return new Proxy(e, {
    get: (n, a) => {
      const o = Object.keys(w).find(
        (d) => Vt(d) === a
      );
      if (!o)
        throw new Error(`No event found for method: ${String(a)}`);
      const i = w[o];
      return (d = {}) => new i(d).track();
    }
  });
}, Wt = _t();
export {
  Ut as ensureMixpanelFlagsReady,
  Mt as getDistinctId,
  Ft as getMixpanelFlagSync,
  N as getMixpanelVariantValueSync,
  Gt as identify,
  Bt as isMixpanelFlagEnabled,
  Lt as resetIdentity,
  Wt as track
};
